<template>
  <div>
    <div ref="dragArea" class="drag-area">
      <div class="drag-btn">
        <el-tooltip effect="dark" content="回到頂部" placement="left">
          <el-button size="mini" icon="el-icon-caret-top" circle @click="toTop"></el-button>
        </el-tooltip>
      </div>
      <div class="line drag-btn2" />
      <div class="drag-btn2">
        <el-tooltip effect="dark" content="返回主頁" placement="left">
          <el-button size="mini" icon="el-icon-s-home" circle @click="floatButton"></el-button>
        </el-tooltip>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    // JS代码
    mounted() {
      /**
       * 监听悬浮拖拽区域
       */
      this.$nextTick(() => {
        // 获取DOM元素
        let dragArea = this.$refs.dragArea;
        // 缓存 clientX clientY 的对象: 用于判断是点击事件还是移动事件
        let clientOffset = {};
        // 绑定鼠标按下事件
        dragArea.addEventListener("mousedown", (event) => {
          let offsetX = dragArea.getBoundingClientRect().left; // 获取当前的x轴距离
          let offsetY = dragArea.getBoundingClientRect().top; // 获取当前的y轴距离
          let innerX = event.clientX - offsetX; // 获取鼠标在方块内的x轴距
          let innerY = event.clientY - offsetY; // 获取鼠标在方块内的y轴距
          console.log(offsetX, offsetY, innerX, innerY);
          // 缓存 clientX clientY
          clientOffset.clientX = event.clientX;
          clientOffset.clientY = event.clientY;
          // 鼠标移动的时候不停的修改div的left和top值
          document.onmousemove = function (event) {
            dragArea.style.left = event.clientX - innerX + "px";
            dragArea.style.top = event.clientY - innerY + "px";
            // dragArea 距离顶部的距离
            let dragAreaTop = window.innerHeight - dragArea.getBoundingClientRect().height;
            // dragArea 距离左部的距离
            let dragAreaLeft = window.innerWidth - dragArea.getBoundingClientRect().width;
            // 边界判断处理
            // 1、设置左右不能动
            // dragArea.style.left = dragAreaLeft + "px";

            // 1.设置左侧边界
            if (dragArea.getBoundingClientRect().left <= 0) {
              dragArea.style.left = "0px";
            }
            // 2.设置右侧边界
            if (dragArea.getBoundingClientRect().left >= dragAreaLeft) {
              dragArea.style.left = dragAreaLeft + "px";
            }
            // 3、设置顶部边界
            if (dragArea.getBoundingClientRect().top <= 0) {
              dragArea.style.top = "0px";
            }
            // 4、设置底部边界
            if (dragArea.getBoundingClientRect().top >= dragAreaTop) {
              dragArea.style.top = dragAreaTop + "px";
            }
          };
          // 鼠标抬起时，清除绑定在文档上的mousemove和mouseup事件；否则鼠标抬起后还可以继续拖拽方块
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        }, false);
        // 绑定鼠标松开事件
        dragArea.addEventListener('mouseup', (event) => {
          let clientX = event.clientX;
          let clientY = event.clientY;
          if (clientX === clientOffset.clientX && clientY === clientOffset.clientY) {
            console.log('click 事件');
          } else {
            console.log('drag 事件');
          }
        })
      });
    },
    methods: {

      floatButton() {
        //这里写点击按钮后你想要实现的功能
        this.$confirm('返回主頁，資料不會被儲存。', '溫馨提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit("FINISH_SETP");
        }).catch(() => {});

      },
      toTop() {
        // 回到顶部
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

    }
  }

</script>

// css代码
<style>
  .drag-area {
    position: fixed;
    right: 0;
    bottom: 200px;
    z-index: 99999;
    padding: 13px;
    height: 70px;
    width: fit-content;
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-shadow: 0px 2px 15px 0px rgba(9, 41, 77, 0.15);
    cursor: move;
    user-select: none;
    text-align: center;
  }

  .drag-btn {
    /* display: flex; */
  }

  .drag-btn2 {
    /* display: flex; */
    margin-top: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/DragButton/index.vue